import { z } from "zod";

import { filter } from "~/tools/filter";
import { isPresent } from "~/tools/is-present";
import { Template } from "~/tools/template";

export const dashboardMetricsMatchers = z
	.array(
		z
			.string()
			.trim()
			.min(1, "Matcher cannot be empty")
			.transform((trimmed) => Template<null>(trimmed))
			.optional()
			.catch(undefined),
	)
	.transform(filter(isPresent))
	.catch([]);

export type DashboardMetricsMatchers = z.infer<typeof dashboardMetricsMatchers>;
